import { ZERO_DEGREE, ZERO_MARGINS } from "@pdfking/math/constants"
import { NullQ } from "@pdfking/structs"
import type { Atom } from "@pdfking/tfunc"

import type { Layout, LayoutLeaf } from "../types/layout"
import { QuarterTurn } from "./TurnMargins"

/** The page `layout` under `prefix`: its path ends on its number, if it has
 * one, and the side it prints on. */
export const PageLeaf = <D>(
  layout: Extract<Layout<D>, { enum: "page" }>,
  prefix: Atom[]
): LayoutLeaf<D> => {
  const is_front = layout.is_front ?? true
  return {
    block: layout.block ?? 0,
    data: layout.data,
    guid: [
      ...prefix,
      ...(NullQ(layout.page_number) ? [] : [layout.page_number]),
      is_front ? "F" : "R",
    ],
    is_front,
    padding: layout.padding ?? ZERO_MARGINS,
    rotation: QuarterTurn(layout.rotation ?? ZERO_DEGREE),
    size: layout.size,
  }
}
